// src/pages/authors/CreateAuthor.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { AuthorType } from "../../../types/Library";
import { createAuthor } from "../../../services/library/author";
import { routes } from "../../../routes";
import { Button, Card, Flex, Spinner } from "@radix-ui/themes";
import TextFieldComponent from "../../../components/inputs/Textfield/TextfieldComponent";
import toast from "react-hot-toast";
import { ChevronLeftIcon, EnterIcon } from "@radix-ui/react-icons";
import { AuthorFormValidation } from "./AuthorFormValidation";

export const CreateAuthor = () => {
    const navigate = useNavigate();
    const mutation = useMutation({ mutationFn: createAuthor, mutationKey: "createAuthor" });

    const defaultValues: AuthorType = { fullname: "" };

    const { control, handleSubmit, formState: { errors } } = useForm<AuthorType>({
        resolver: yupResolver(AuthorFormValidation),
        defaultValues,
        mode: "onBlur",
    });

    const onSubmit = handleSubmit(async (data) => {
        try {
            await mutation.mutateAsync(data);
            toast.success("Autor criado com sucesso!");
            navigate(routes.authors);
        } catch (error: any) {
            toast.error(`Erro: ${error.message}`);
        }
    });

    const handleBack = () => navigate(routes.authors);

    return (
        <form onSubmit={onSubmit} noValidate>
            <Card size="1">
                <Flex direction="column" gap="4">
                    <TextFieldComponent
                        name="fullname"
                        label="Nome Completo"
                        control={control}
                        errors={errors}
                        fieldProps={{ placeholder: "Nome Completo" }}
                        required={true}
                    />
                    <Flex direction="row" gap="4" style={{ alignSelf: "end" }}>
                        <Button type="button" variant="soft" color="gray" onClick={handleBack} disabled={mutation.isLoading}>
                            <ChevronLeftIcon /> Voltar
                        </Button>
                        <Button type="submit" disabled={mutation.isLoading}>
                            {mutation.isLoading ? <Spinner loading /> : <EnterIcon />}
                            Registar
                        </Button>
                    </Flex>
                </Flex>
            </Card>
        </form>
    );
};
